import React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
} from 'react-bootstrap';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import * as SVGICONS from '../../images/img/images';
// import * as signinActions from '../../actions/signinActions';
import * as appointmentActions from '../../actions/appointmentActions';
import * as specialistActions from '../../actions/specialistActions';
import * as signinActions from '../../actions/signinActions';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import validator from '../common/validator.js';
import './BlockAvailability.css';
import { ToastContainer, toast } from 'react-toastify';

import { blockingTimeArray, REASONOFBLOCKING, blockingMonth, appointmentModeItem } from './timeSLot';
class CreateAppointment extends React.Component {
    constructor(props, context) {
        super(props, context);
        var todayDate = moment.utc(new Date());
        var convertDate = new Date(moment(todayDate).local());
        var currenthour = moment(todayDate).local().format("HH")
        var currentmin = moment(todayDate).local().format("mm")
        this.state = {
            finalTimeSlotReset: blockingTimeArray,
            finalTimeSlot: [],
            finalEndTimeSlot: blockingTimeArray,
            blockingDate: convertDate,
            // initialTimeSlots: TimeSLots,
            // finalTimeSlot :  TimeSLots,
            selectedAppointmentDate: Date,
            currenthour: currenthour,
            currentmin: currentmin,
            fetchSpecialistData: false,
            appointmentDatesGetched: false,
            isLoading: true,
            specialistDetail: [],
            startTime: blockingTimeArray[0],
            endTime: blockingTimeArray[1],
            reasonForBlocking: [],
            finalBlockingObj: {
                startDate: null,
                endDate: null,
                reason: REASONOFBLOCKING[0],
                noOfRecursion: 20,
                startTime: null,
                endTime: null,
                daysBlocked: [
                    'tuesday', 'wednesday', 'friday'
                ],
            },
            dateToBlock: convertDate.getDate(),
            monthToBlock: convertDate.getMonth() + 1,
            editTabClicked: false,

            isInitialRender: true,
            appointmentDate : new Date(),
            clinetlocation: '',
            userlocation : moment.tz.guess(),
            specialistId: localStorage.getItem('userId'),
            appointmentModeItem: appointmentModeItem,
            selectedAppointmentMode: appointmentModeItem[0],
            appointmentMode: appointmentModeItem[0].value,
            email: { value: '', isValid: true, message: '' },
            name: { value: '', isValid: true, message: '' },
            paymentMethod: 'card',
            availabilityId: '',
            initialClinicSelected: false,
            submitted: false,
            errors: {
                selectedClinic: '',
                selectedTiming: ''
            }

        };
    }


    componentDidMount() {
        const { specialistDetailForAppointment } = this.props;
        if (specialistDetailForAppointment && this.state.isInitialRender) {
            let availabilityId = specialistDetailForAppointment[0]._id;
            let doctoraddress = specialistDetailForAppointment[0].addressLineOne;
            let clinetlocation = specialistDetailForAppointment[0].contryzone;

            let totalClinics = specialistDetailForAppointment && specialistDetailForAppointment.map(availability => {
                return {
                    value: availability._id,
                    label: availability.clinicName,
                    clinetlocation: availability.contryzone
                }
            })
            this.setState({ availabilityId, doctoraddress, clinetlocation, isInitialRender : false, totalClinics }, () => {
            this.getSpecialistAvailability();
            // this.props.appointmentactions.getSpecialistDetailCalendar(appointmentObj, this.props);
            // this.props.appointmentactions.getBlockAppointmentDate(appointmentObj, this.props);
            });
        }
    }

    getSpecialistAvailability = () => {
        let appointmentObj = {};
        const { specialistDetailForAppointment } = this.props;
        const { appointmentDate, userlocation, specialistId,
            availabilityId, doctoraddress, clinetlocation } = this.state;
        // let specialistId = localStorage.getItem('userId');
        var currenthour = moment(appointmentDate).local().format("HH");
        var currentmin = moment(appointmentDate).local().format("mm");
        appointmentObj.appointmentDate = appointmentDate;
        appointmentObj.currenthour = currenthour;
        appointmentObj.currentmin = currentmin;
        appointmentObj.userlocation = userlocation;
        appointmentObj.specialistId = localStorage.getItem("userId");
        appointmentObj.userId = localStorage.getItem("userId");
        appointmentObj.availabilityId = availabilityId;
        appointmentObj.doctoraddress = doctoraddress;
        appointmentObj.clinetlocation = clinetlocation;
        // appointmentObj.appointmentDate = appointmentDate;availabilityId: availabilityId,
        // appointmentObj.appointmentDate = appointmentDate;
        console.log("appointmentonj", appointmentObj, localStorage.getItem("userId"))
        // return;
        this.props.appointmentactions.getBlockAppointmentDate(appointmentObj, this.props);
        this.props.appointmentactions.getSpecialistAvailability(appointmentObj, this.props);

    }

    handleChangeStartTime = selectedOption => {
        this.setState({ appointmentTimeSlot: selectedOption.value, appointmentTimeSlotObj: {
            value: selectedOption.value,
            label: selectedOption.value
        }, errors: {
        ...this.state.errors,
        selectedTiming: ''
        } })
    };

    handleAppointmentModeItem = selectedOption => {
        this.setState({ 
            appointmentMode : selectedOption.value,
            selectedAppointmentMode: {
                value: selectedOption.value,
                label: selectedOption.label
            }
        }, () => {
            if (this.state.appointmentMode == '2') {
                this.setState({
                    paymentMethod: 'card'
                })
            }
        });
    };

    // changeReasonForBlocking = (selectedOption) => {

    //     this.props.changeReasonForBlocking(selectedOption);
    //     this.setState({
    //         reason: selectedOption,
    //         finalBlockingObj: {
    //             ...this.state.finalBlockingObj,
    //             reason: selectedOption.value
    //         }
    //     }, () => {


    //     })
    // };

    blockingDateChanged = (selectedDate) => {
        let isToday = moment(selectedDate).isSame(new Date(), 'day');
        let getDateToStart = moment(selectedDate).startOf('day')._d;
		// var selDate = moment.utc(selectedDate);
		// var convertedDate = new Date(moment(selDate).local());
        
        let convertDate = new Date(moment(getDateToStart).local())
        let todayIsTrue = new Date(moment(selectedDate).local())
        // console.log("--create->>2", todayDate)
        // var convertDate = new Date(moment(todayDate).local());
        // console.log("converted date");
        // new Date(moment(moment.utc(selectedDate)).local())
        // staring from 1 so 
        // let yearlyMonthSelected = blockingMonth[convertDate.getMonth() + 1];
        this.setState({
            // daysBlocked: [...this.state.daysBlocked, weeklyDaySelected],
            // appointmentDatesGetched: true,
            // dateToBlock: convertDate.getDate(),
            // monthToBlock: yearlyMonthSelected,
            // appointmentDate: new Date(moment(moment.utc(selectedDate).startOf('day')).local()),
            // appointmentDate: new Date(moment(moment.utc(selectedDate)).local()),
            appointmentDate: isToday ? todayIsTrue : convertDate,
            appointmentTimeSlot: '',
            appointmentTimeSlotObj: {
                value: 'Select Time',
                label: 'Select Time'
            }
        }, () => {
            this.getSpecialistAvailability();
        })
        // })

    }


    submitBlockAvailability = (periodToBlock) => {

        const { appointmentDate, userlocation, specialistId,
            availabilityId, doctoraddress, clinetlocation,
            appointmentTimeSlot,
            appointmentMode,
            initialClinicSelected,
            name
        } = this.state;
        console.log("ddd", this.state)
        if (!initialClinicSelected) {
            this.setState({
                errors: {
                    selectedClinic: 'clinic is required'
                }
            });
            return;
        }
        if (!appointmentTimeSlot) {
            this.setState({
                errors: {
                    selectedTiming: 'Appointment time is required'
                }
            });
            return;
        }
        if (this.state.email.value == '') {
            
            this.setState({
                email: {
                    message: 'Email is required'
                }
            })
            return
        } else if (!validator.isEmail(this.state.email.value)) {
            this.setState({
                email: {
                    message: 'Not a valid email address'
                }
            })
            return
        }
        let appointmentObj = {
            availabilityId,
            // patientId: patientId,
            // patientId: "5d27a10515f95102d23c0f8f",
            appointmentDate,
            appointmentTime: appointmentTimeSlot,
            clinetlocation,
            userlocation,
            appointmentMode,
            // userName: 'new User',
            firstName: name.value,
            createdBy: 'Specialist',
            paymentMethod: this.state.paymentMethod,
            email: this.state.email.value,
            userType: '1'
        };
        console.log("==>>", appointmentObj)
        // return
        this.setState({
            submitted: true
        }, () => {
            this.props.appointmentactions.bookAppointment(appointmentObj, this.props);
        })
    }

    handleCurrentlySelectedClinic = (selectedOption) => {
        this.setState({ availabilityId: selectedOption.value,
            appointmentTimeSlot: '',
            initialClinicSelected: true,
            clinetlocation: selectedOption.clinetlocation,
            errors: {
                ...this.state.errors,
                selectedClinic: ''
            },
            currentlySelectedClinic: {
            value: selectedOption.value,
            label: selectedOption.label,
        }, appointmentTimeSlotObj: {
            value: 'Select Time',
            label: 'Select Time'
        }}, () => this.getSpecialistAvailability())
    }

    onChange = (e) => {
        var state = this.state;
        state[e.target.name].value = e.target.value;
        // this.resetValidationStates();
        if (e.target.name == "email") {
            if (e.target.value.length > 0) {
                if (!validator.isEmail(state.email.value)) {
                    state.email.isValid = false;
                    state.email.message = 'Not a valid email address';
                    this.setState(state);
                } else {
                    state.email.isValid = true;
                    state.email.message = '';
                    this.setState(state);
                    // return true
                }
            } else {
                state.email.isValid = false;
                state.email.message = 'Email address is required';
                this.setState(state);
            }

        }
        this.setState(state);
    }

    changePaymentMethod = (e) => {
		this.setState({
			paymentMethod: e.currentTarget.value
		})
    }
    
    // createNewPatient = () => {
    //     var signup = {
    //         userType: parseInt(1),
    //         email: this.state.email.value,
    //         password: "Medfix@2020",
    //         cpassword: "Medfix@2020",
    //         createdBy: 'Specialist',
    //     }
    //     this.props.signinActions.signUpUser(signup);
    // }

    render() {
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');
        let finalTimeSlot = [];
        let timeBlocked =  ['1'];
        if (this.state.initialClinicSelected) {
            timeBlocked =  this.props.specialistBlockDates ?
            (this.props.specialistBlockDates.timeBlocked ? this.props.specialistBlockDates.timeBlocked
                : timeBlocked) : timeBlocked;
                let fetchedTimeSlots = this.props.specialistSlots.finalSlot;
                fetchedTimeSlots && fetchedTimeSlots.forEach( time => {
                if (time.status != 1 && !timeBlocked.includes(time.slot) )
                    finalTimeSlot.push({
                        value: time.slot,
                        label: time.slot + " " + userlocation
                    });
            });
        }
        var { email, name } = this.state;
        return (
            <>
            <ToastContainer  position="bottom-left" rtl={true}/>
            <Modal className="blockAvailability" show={this.props.openBlockAvailability} size="lg" onHide={this.props.closeBlockAvailability}>
                <Modal.Header closeButton>
                    <Modal.Title align="left">
                        <h4> Create Appointment</h4>
                        <span style={{ marginLeft: "-80px" }} className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg mobileposavr00" data-title="Create Appointment for the Patient">
                            <span style={{ width: "18px", marginLeft: "" }}>
                                <SVGICONS.Helppic />
                            </span>
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Date</label>
                            </div>
                            <div className="col-lg-5">
                                <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                    <div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
                                        <div className="input-group-addon">
                                            <img src={require('../../images/img/date_input_icon.svg')} />
                                            {/* <img src={require('../../images/icons/calendar.svg')} /> */}
                                        </div>
                                        <DatePicker
                                            name="blockingdate"
                                            dateFormat="dd-MM-yyyy"
                                            selected={this.state.appointmentDate}
                                            onChange={this.blockingDateChanged}
                                            placeholderText="Date"
                                            // maxDate={moment().add(1, 'year')}
                                            minDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            shouldCloseOnSelect={true}
                                        // dropdownMode="select"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Clinic</label>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                            {/* <img src={require('../../images/icons/circular-wall-clock.svg')} /> */}
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.currentlySelectedClinic || ''}
                                            onChange={this.handleCurrentlySelectedClinic}
                                            options={this.state.totalClinics || []}
                                        // defaultValue={this.state.finalTimeSlot[0].value}
                                        />
                                    </div>
                                    <div>
                                    {this.state.errors.selectedClinic && <span className="help-block">{this.state.errors.selectedClinic}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Time</label>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                            {/* <img src={require('../../images/icons/circular-wall-clock.svg')} /> */}
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.appointmentTimeSlotObj || ''}
                                            onChange={this.handleChangeStartTime}
                                            options={finalTimeSlot || []}
                                        // defaultValue={this.state.finalTimeSlot[0].value}
                                        />
                                    </div>
                                    <div>
                                    {this.state.errors.selectedTiming && <span className="help-block">{this.state.errors.selectedTiming}</span>}

                                        {/* <span className="help-block">{this.props.friday && this.props.fridayEveningSchedule.message}</span> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Mode</label>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.selectedAppointmentMode}
                                            onChange={this.handleAppointmentModeItem}
                                            options={this.state.appointmentModeItem}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Email</label>
                            </div>
                            <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.EmailSvg />
                                            {/* <img src={require('../../images/icons/circular-wall-clock.svg')} /> */}
                                        </span>
                                        <input autoComplete="new-password" type="text" name="email" className="form-control"
                                            placeholder="Email Address" value={email.value} onChange={this.onChange}  autoFocus />
                                        <span className="help-block">{email.message}</span>
                                        
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                                <div className="btnSubmit text-center">
                                {!email.message && <button className="btn btn-primary" onClick={this.createNewPatient}>Check</button>}
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Name</label>
                            </div>
                            <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <i className="fa ">
                                                <img src={require('../../images/img/user_input_icon.svg')} alt="" />
                                            </i>
                                        </span>
                                        {/* <span className="input-group-addon">
                                            <SVGICONS.EmailSvg />
                                        </span> */}
                                        <input type="text" name="name" className="form-control"
                                            placeholder="Name" value={name.value} onChange={this.onChange}  autoFocus />

                                        {/* <span className="help-block">{email.message}</span> */}
                                        
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                                <div className="btnSubmit text-center">
                                {!email.message && <button className="btn btn-primary" onClick={this.createNewPatient}>Check</button>}
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-1" id="inputGroupPrepend">
                                <label className="label">Payment</label>
                            </div>
                            <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8 appoConfirm">
                            <div className="radio radio-primary radio-period" style={{marginLeft: "19px", marginTop: "-4px"}}>
                                    <input id="cash" type="radio" name="optradio" value="cash" checked={this.state.paymentMethod == 'cash'} disabled={this.state.appointmentMode == '2'} onChange={this.changePaymentMethod}/>
                                    <label htmlFor="cash">
                                        Cash
                                    </label>
                                </div>
                                <div className="radio radio-primary radio-period" style={{"margin-left": "19px", "margin-top": "-4px"}}>
                                    <input type="radio" name="optradio" id="card" value="card" checked={this.state.paymentMethod == 'card'} onChange={this.changePaymentMethod}/>
                                    <label htmlFor="card">
                                        Card
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btnSubmit text-center">
                        {/* <button onClick={()=>this.submitBlockAvailability('daily')} className="btn btn-primary">Submit</button> */}
                        {/* <button onClick={()=>this.submitBlockAvailability('weekly')} className="btn btn-primary">Submit</button> */}
                        <button disabled={this.state.submitted} onClick={() => this.submitBlockAvailability('yearly')} className="btn btn-primary">Submit</button>
                        {/* <button onClick={()=>this.submitBlockAvailability('yearly')} className="btn btn-primary">Submit</button> */}
                    </div>


                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal >
            </>
        );
    }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
    return {
        specialistDetail: state.specialist.specialistDetail,
        appointments: state.specialist.appointments,
        specialistAvailability: state.appointment.specialistAvailability,
        specialistDetailForAppointment: state.specialist.specialistDetailForAppointment,
        specialistSlots: state.appointment.specialistAvailability,
		specialistBlockDates: state.appointment ? state.appointment.specialistBlockedDates : null
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(specialistActions, dispatch),
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
		signinActions: bindActionCreators(signinActions, dispatch)

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAppointment);